import { render, staticRenderFns } from "./RootVariables.vue?vue&type=template&id=4635bcb0&"
import script from "./RootVariables.vue?vue&type=script&lang=js&"
export * from "./RootVariables.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports